// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchCompositeInstancesInternalRequest
 */
export interface HandlersPatchCompositeInstancesInternalRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof HandlersPatchCompositeInstancesInternalRequest
   */
  ids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstancesInternalRequest
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchCompositeInstancesInternalRequest
   */
  neo4jVersion?: string;
}

/**
 * Check if a given object implements the HandlersPatchCompositeInstancesInternalRequest interface.
 */
export function instanceOfHandlersPatchCompositeInstancesInternalRequest(
  value: object,
): value is HandlersPatchCompositeInstancesInternalRequest {
  return true;
}

export function HandlersPatchCompositeInstancesInternalRequestFromJSON(
  json: any,
): HandlersPatchCompositeInstancesInternalRequest {
  return HandlersPatchCompositeInstancesInternalRequestFromJSONTyped(
    json,
    false,
  );
}

export function HandlersPatchCompositeInstancesInternalRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchCompositeInstancesInternalRequest {
  if (json == null) {
    return json;
  }
  return {
    ids: json['ids'] == null ? undefined : json['ids'],
    memory: json['memory'] == null ? undefined : json['memory'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
  };
}

export function HandlersPatchCompositeInstancesInternalRequestToJSON(
  json: any,
): HandlersPatchCompositeInstancesInternalRequest {
  return HandlersPatchCompositeInstancesInternalRequestToJSONTyped(json, false);
}

export function HandlersPatchCompositeInstancesInternalRequestToJSONTyped(
  value?: HandlersPatchCompositeInstancesInternalRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ids: value['ids'],
    memory: value['memory'],
    neo4jVersion: value['neo4jVersion'],
  };
}
